import React, { useEffect } from "react";
import HeroProduct2 from "../../components/Produk/Produk2/HeroProduct2";
import HowItWorksProduct2 from "../../components/Produk/Produk2/HowItWorksProduct2";
import SuitForProduct2 from "../../components/Produk/Produk2/SuitForProduct2";
import PainPointProduct2 from "../../components/Produk/Produk2/PainPointProduct2";
import SolutionProduct2 from "../../components/Produk/Produk2/SolutionProduct2";
import ValueBenefitsProduct2 from "../../components/Produk/Produk2/ValueBenefitsProduct2";
import GuaranteeScoreProduct2 from "../../components/Produk/Produk2/GuaranteeScoreProduct2";
import BonusProduct2 from "../../components/Produk/Produk2/BonusProduct2";
import TestimonialsProduct2 from "../../components/Produk/Produk2/TestimonialsProduct2";
import PriceProduct2 from "../../components/Produk/Produk2/PriceProduct2";
import SyllabusProduct2 from "../../components/Produk/Produk2/SyllabusProduct2";
import CTAProduct2 from "../../components/Produk/Produk2/CTAProduct2";

const Product2 = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <div className="min-h-screen">
      <HeroProduct2 />
      <PainPointProduct2 />
      <SolutionProduct2 />
      <ValueBenefitsProduct2 />
      <GuaranteeScoreProduct2 />
      <TestimonialsProduct2 />
      <HowItWorksProduct2 />
      <SuitForProduct2 />
      <BonusProduct2 />
      <PriceProduct2 />
      <SyllabusProduct2 />
      <CTAProduct2 /> 
    </div>
  );
};

export default Product2;
